import axios from 'axios'
import React, { useEffect, useState } from 'react'
import Container from 'client/components/container.js'
import Http404 from './errors/404'
import AuthService from 'client/utils/auth-service.js'
import { useParams } from 'react-router-dom'

const Component = () => {
  const [containerProps, setContainerProps] = useState({ auth: null, client: null, error: false })

  const params = useParams()

  useEffect(() => {
    getComponent()
  }, [])

  const getComponent = async () => {
    try {
      const { org = 'default' } = params
      console.log(org, 'org')
      const { data: client } = await axios.get(`/api/v1/connections/${org}`)
      const auth = new AuthService(client)
      setContainerProps({ auth, client, error: false })
    } catch (e) {
      setContainerProps({ auth: null, client: null, error: true }) // render a 404 page if an org isn't found
    }
  }
  return (
    <div>
      {containerProps.error === false ? <Container auth={containerProps.auth} client={containerProps.client} /> : <Http404 />}
    </div>
  )
}
export default Component
